import * as React from "react";
const SvgMsgIsPending = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}><g transform="translate(-3)" fill="none"><circle cx={10} cy={7} r={6} /><path d="M10 3.5V7M12 9l-2-2" /></g></svg>;
export default SvgMsgIsPending;